/**
 * Utility functions
 */

import { clsx, type ClassValue } from 'clsx';

/**
 * Combines class names with clsx
 * Use this for conditional and merged Tailwind classes
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
